import type { TGlobalTopicFavoriteList } from './global-topic-favorite-list.types'
import { GlobalTopicsTableView } from '../global-topics-table'

export const GlobalTopicFavoriteListView = ({
  data,
  error,
  handleSetOrder,
  hasMore,
  isFetchingMore,
  isLoading,
  order,
  refetch,
  sentryRef,
  totalCount,
}: TGlobalTopicFavoriteList) => {
  return (
    <div className="GlobalTopicFavoriteList">
      <GlobalTopicsTableView
        data={data}
        error={error}
        handleSetOrder={handleSetOrder}
        hasMore={hasMore}
        isFetchingMore={isFetchingMore}
        isLoading={isLoading}
        refetch={refetch}
        totalCount={totalCount}
        order={order}
        sentryRef={sentryRef}
      />
    </div>
  )
}
